<div class="status-div">
  <p class="status-message">Clique no botão "Confirmar Status" para atualizar a denúncia.</p>
  <button (click)="putStatusDenounce()" class="confirm-button">Confirmar Status</button>
</div>


